import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HoldOnConfig } from '../../@temas/holdOn/holdOn';
import { environment } from '../../../environments/environment';
import { NotificacionesConfig } from '../../@temas/notificaciones/notificaciones';
import { AutenticacionService } from '../servicios/autenticacion.service';
import { PermisosService } from '../servicios/permisos.service';
import { ErrorService } from '../servicios/error.service';


@Component({
    selector: 'app-sesion',
    templateUrl: './sesion.component.html',
    styleUrls: ['./sesion.component.scss']
})
export class SesionComponent implements OnInit {

    public correoForm: FormGroup;
    public userName: string;
    public password: string;
    public recordarUsuario = false;
    public typeInput: string;
    public iconTypeInput: string;
    public displayFormsLogin = '';
    public displayFormsCorreo = 'display-forms';
    public displayFormsLoginRemember = 'display-forms';
    public ipApi = environment.apiUrl;
    private returnPage: string;

    public UsuarioRecordatorio: any;
    constructor(
        private formBuiler: FormBuilder,
        private holdOn: HoldOnConfig,
        private notificacion: NotificacionesConfig,
        private auth: AutenticacionService,
        private PermisosService: PermisosService,
        private errorService: ErrorService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        if (this.auth.isLogged()) { this.router.navigateByUrl('/'); }
        this.typeInput = 'password';
        this.iconTypeInput = 'fa-eye';
    }

    ngOnInit() {
        this.correoForm = this.formBuiler.group({
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.pattern('^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$')
                ])
            ]
        });

        //Verifica si hay un usuario recordado/guardado
        if (localStorage.getItem('UsuarioRecordatorio') === null) {
            this.UsuarioRecordatorio = {
                Imagen: null,
                NombrePersonal: null
            };
            this.displayFormsLoginRemember = 'display-forms';
            this.displayFormsLogin = '';
        } else {
            this.UsuarioRecordatorio = JSON.parse(localStorage.getItem('UsuarioRecordatorio'));
            this.displayFormsLoginRemember = '';
            this.displayFormsLogin = 'display-forms';
        }

        this.route.queryParams.subscribe((params: any) => (this.returnPage = params.return || '/'));
    }

    public async onSubmit() {
        this.autenticar();
    }

    public async autenticar() {
        this.holdOn.open('Cargando..!');
        if (!this.userName || !this.password) {
            this.holdOn.close();
            this.notificacion.error('Debe digitar el usuario y la contraseña');
        } else {
            this.auth.authenticate(this.userName, this.password).pipe(first()).subscribe(
                async (result) => {
                    if (result.autenticado) {
                
                        /*Obtener el menu*/

                        await this.PermisosService.obtenerMenu().then((res) => {
                            this.PermisosService.setMenu(res['datos']);
                        });

                        /*Obtener el permisos*/
                        await this.PermisosService.ObtenerPermisos().then((res) => {
                            this.PermisosService.setPermisos(res['datos']);
                        });

                        
                        /*Recordar contraseña*/
                        if (this.recordarUsuario) {
                            localStorage.setItem('TokenRecordatorio', localStorage.getItem('UsuarioToken'));
                            localStorage.setItem('UsuarioRecordatorio', localStorage.getItem('UsuarioActual'));
                        } else {
                            localStorage.removeItem('TokenRecordatorio');
                            localStorage.removeItem('UsuarioRecordatorio');
                        }


                        this.router.navigateByUrl('/modulo');
                        this.holdOn.close();
                    } else {
                        this.holdOn.close();
                        this.notificacion.error(result.mensaje);
                    }
                },
                (error) => {
                    this.holdOn.close();
                    this.errorService.handleError(error);
                }
            );
        }
    }

    enviarCorreo(form) {
        this.holdOn.open('Cargando..!');
        if (form.valid) {
            this.auth.recuperarContrasena(form.get('email').value).pipe(first()).subscribe(
                (result) => {
                    if (result.exito) {
                        this.notificacion.success(result.mensaje);
                        this.mostrarFormLogin();
                        this.holdOn.close();
                    } else {
                        this.notificacion.error(result.mensaje);
                        this.holdOn.close();
                    }
                },
                (error) => {
                    this.errorService.handleError(error);
                    this.holdOn.close();
                }
            );
        } else {
            this.notificacion.error('Correo Invalido');
            this.holdOn.close();
        }
    }

    mostrarPassword() {
        if (this.typeInput === 'text') {
            this.typeInput = 'password';
            this.iconTypeInput = 'fa-eye';
        } else {
            this.typeInput = 'text';
            this.iconTypeInput = 'fa-eye-slash';
        }
    }

    mostrarFormRecuperarContresena() {
        this.displayFormsLogin = 'display-forms';
        this.displayFormsCorreo = '';
        //this.correoForm.reset();
    }

    mostrarFormLogin() {
        this.displayFormsLogin = '';
        this.displayFormsCorreo = 'display-forms';
        this.displayFormsLoginRemember = 'display-forms';
    }

    mostrarFormsLoginRemember() {
        this.displayFormsLogin = 'display-forms';
        this.displayFormsCorreo = 'display-forms';
        this.displayFormsLoginRemember = '';
    }

    iniciarUsuarioGuardado() {
        this.holdOn.open('Cargando...!');

        localStorage.setItem('UsuarioToken', localStorage.getItem('TokenRecordatorio'));
        localStorage.setItem('UsuarioActual', localStorage.getItem('UsuarioRecordatorio'));

        this.router.navigateByUrl('/');

        this.holdOn.close();

    }
}